import React from 'react';
import PropTypes from 'prop-types';

const ProfileTagInformationItem = props => {
  const { record } = props;
  const { Date, FullName, Tags } = record;
  return (
    <div
      className="sidebar__table-row profile-tag-information__row sidebar__table-row--stacked"
      style={{
        flexDirection: 'column',
      }}
    >
      <div className="sidebar__table-row-inner">
        <div
          className="sidebar__table-column"
          style={{
            flex: '1 1 155px',
          }}
        >
          <span
            style={{
              fontWeight: '600',
              fontSize: '0.8571rem',
              fontFamily: 'Noto Sans',
            }}
          >
            {FullName}
          </span>
        </div>
        <div
          className="sidebar__table-column"
          style={{
            flex: '1 1 50px',
            marginRight: 0,
          }}
        >
          <div className="sidebar__text">{Date}</div>
        </div>
      </div>
      {Object.keys(Tags).map((key, index) => (
        <div key={index} className="sidebar__text">
          <span className="sidebar__text sidebar__text--accent">{key}: </span>
          {Tags[key].join(', ')}
        </div>
      ))}
    </div>
  );
};

ProfileTagInformationItem.propTypes = {
  record: PropTypes.object.isRequired,
};

export default ProfileTagInformationItem;
